import React from 'react'
import { Field } from 'redux-form'
import BooleanToggleField from '../../../../components/Form/BooleanToggleField'

// binding for redux-form
const Input = ({ input: { value, onChange }, editable, disabled, t }) => (
    <BooleanToggleField
        value={value ?? true}
        onChange={onChange}
        disabled={disabled || !editable}
        t={t}
    />
)

// the binding function has to be outside to avoid re-rendering
// https://github.com/erikras/redux-form/issues/1094

const BooleanToggle = ({ field, t, objectMode }) => (
    <Field
        name={field.path}
        component={Input}
        editable={!field.editable ? objectMode === 'newObject' : field.editable}
        disabled={field.disabled}
        t={t}
    />
)

export default BooleanToggle